/**
 * Converts any value to a safe string representation
 */
export function toText(val: any): string {
  if (val == null) return '';
  try {
    return String(val);
  } catch {
    return '';
  }
}

/**
 * Normalizes a string for comparison:
 * - Converts to lowercase
 * - Removes diacritics
 * - Trims whitespace
 */
export function normalize(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}+/gu, '')
    .trim();
}

/**
 * Checks if a value matches a query string
 * Supports multi-token matching (all tokens must be found)
 */
export function matches(haystack: any, query: string): boolean {
  const h = normalize(toText(haystack));
  const q = normalize(query);
  if (!q) return true;
  
  // Multi-token contains - all tokens must be found
  const tokens = q.split(/\s+/).filter(t => t.length > 0);
  return tokens.every(tok => h.includes(tok));
}




